import {DateTime} from 'luxon';

/**
 * This will use luxon to parse the event date time from the timestamp
 * format EventModel uses, and returns a luxon DateTime object
 *
 * This supports timezones, and will default to UTC if not provided.
 *
 * @param eventTimestamp string
 * @param eventTimezone string
 * @returns DateTime
 */

export const parseEventDateTime = (eventTimestamp: string, eventTimezone?: string): DateTime => {
  return DateTime.fromISO(eventTimestamp, {setZone: true, zone: eventTimezone || 'UTC'});
};

export const eventDatesHaveSameDay = (date1: string, date2: string): boolean => {
  const date1Parsed = parseEventDateTime(date1);
  const date2Parsed = parseEventDateTime(date2);
  return (
    date1Parsed.year === date2Parsed.year &&
    date1Parsed.month === date2Parsed.month &&
    date1Parsed.day === date2Parsed.day
  );
};

export const isDateTimeInPast = (timestamp: string): boolean => {
  const dateTime = parseEventDateTime(timestamp);
  return dateTime.isValid && dateTime < DateTime.now();
};
